import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import styles from './modalDialog.module.css';

const getModalClass = (isLarge) =>
  (isLarge
    ? `${styles.modalDialog} ${styles.large}`
    : styles.modalDialog);

const ModalDialog = ({
  isOpen, children, onConfirm, onCancel,
  confirmTranslationKey, cancelTranslationKey, isLarge, isValid, title, variantButtons
}) => {
  // All of the old modals use the UH-styleguide "action buttons" -- added this so that we can
  // use the UH-styleguide "normal buttons" with outlines etc. without changing the existing ones.
  const buttonBaseClass = styles.modalButton;
  const confirmButtonStyle = [
    variantButtons ? 'button' : 'button--action',
    !isValid ? 'disabled' : '',
    buttonBaseClass
  ].join(' ');

  const cancelButtonStyle = [
    variantButtons ? 'button--outline' : 'button--action',
    buttonBaseClass
  ].join(' ');

  return (
    <div className={styles.modalOverlay} style={{ display: isOpen ? 'flex' : 'none' }}>
      <div className={getModalClass(isLarge)} data-cy="modal-dialog">
        {title && <h4 className={styles.modalTitle}><Translate id={title} /></h4>}
        <div>
          {children}
        </div>
        <div className={`${styles.modalButtons}`}>
          <button type="button" id="cancel" className={cancelButtonStyle} onClick={onCancel} data-cy="cancel-button">
            <Translate id={cancelTranslationKey} />
          </button>
          <button disabled={!isValid} id="confirm" type="button" className={confirmButtonStyle} onClick={onConfirm} data-cy="confirm-button">
            <Translate id={confirmTranslationKey} />
          </button>
        </div>
      </div>
    </div>
  );
};

ModalDialog.defaultProps = {
  confirmTranslationKey: 'common.yes',
  cancelTranslationKey: 'common.no',
  isLarge: false,
  isValid: true,
  children: null,
  title: null,
  variantButtons: false
};

const {
  bool, func, node, string
} = PropTypes;
ModalDialog.propTypes = {
  isOpen: bool.isRequired,
  children: node,
  onConfirm: func.isRequired,
  onCancel: func.isRequired,
  confirmTranslationKey: string,
  cancelTranslationKey: string,
  isValid: bool,
  isLarge: bool,
  title: string,
  variantButtons: bool
};

export default ModalDialog;
